import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Card, CardContent, Grid, Typography, Avatar } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import PeopleIcon from '@mui/icons-material/PeopleOutlined';
import { FormattedMessage,injectIntl } from 'react-intl';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%'
  },
  content: {
    alignItems: 'center',
    display: 'flex'
  },
  title: {
    fontWeight: 700
  },
  avatar: {
    backgroundColor: theme.palette.success.main,
    height: 56,
    width: 56
  },
  icon: {
    height: 32,
    width: 32
  },
  difference: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  differenceIcon: {
    color: theme.palette.success.dark
  },
  differenceIconSucess: {
    color: 'green'
  },
  differenceValue: {
    color: theme.palette.success.dark,
    marginRight: theme.spacing(1)
  },
}));

const TotalUsers = props => {
  const { className, total, comparation, positiveMonth} = props;
  const intl = props.intl;

  const classes = useStyles();

  // console.log("compartion >>>>");

  // if(Number.isNaN(comparation)){
  //   comparation = 0;
  // }
  // console.log(Number.isNaN(comparation));
  // console.log(comparation);

  // comparation = 0;


  return (
    <Card
      className={clsx(classes.root, className)}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
        >
          <Grid item>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              variant="body2"
            >
              {<FormattedMessage id="general.satisf" />}
            </Typography>
            <Typography variant="h3">{total}</Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <PeopleIcon className={classes.icon} />
            </Avatar>
          </Grid>
        </Grid>
        <div className={classes.difference}>
          {positiveMonth && (
            <ArrowUpwardIcon className={classes.differenceIconSucess} />
          )}
          {!positiveMonth && (
            <ArrowDownwardIcon className={classes.differenceIcon} />
          )}
          <Typography
            className={positiveMonth ? classes.differenceIconSucess : classes.differenceIcon}
            variant="body2"
          >
            {comparation}%
          </Typography>
          <Typography
            className={classes.caption}
            variant="caption"
          >
            &nbsp; {<FormattedMessage id="relation.last.mounth" />}
          </Typography>
        </div>
      </CardContent>
    </Card>
  );
};

TotalUsers.propTypes = {
  className: PropTypes.string,
  total: PropTypes.number,
  comparation: PropTypes.number,
  positiveMonth: PropTypes.bool
};

export default injectIntl(TotalUsers);
